<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("barcode_print") }}</h4>
        </div>
      </div>
      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link to="/print/barcodes" class="btn btn-added">
              <span>Back</span>
            </router-link>
          </div>
        </li>
        <li>
          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
        </li>
      </ul>
    </div>

    <div class="card table-list-card p-3 bg-white fs-7">
      <form @submit.prevent="printBarcodes" enctype="multipart/form-data">
        <!-- Header Form Section -->
        <div class="row gy-2 gx-4 mb-3 justify-content-between align-items-center">
          <div class="col-md-6 d-flex align-items-start">
            <label class="form-label small mb-0 me-3" style="width:85px;">{{$t('select_item')}}:</label>
            <div class="flex-grow-1 position-relative">
              <!-- Search Input -->
              <input
                type="text"
                v-model="query"
                @input="searchItems"
                :placeholder="$t('search_item_by_name_barcode')"
                class="form-control"
                @keydown="handleKeys"
              />

              <!-- Dropdown Search Results -->
              <div
                v-if="query"
                class="search-results shadow rounded bg-white position-absolute mt-1"
                style="width:100%; max-height: 350px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
                :class="{ 'd-block': results.length > 0, 'd-none': results.length === 0 }"
              >

                <!-- Results List -->
                <ul class="list-group list-group-flush">
                  <li
                    v-for="(item, index) in results"
                    :key="item.id"
                    class="list-group-item d-flex justify-content-between align-items-center"
                    :class="{ 'bg-primary text-white': index === itemIndex }"
                    style="padding: 10px; font-size: 0.95rem; cursor: pointer;"
                  >
                    <!-- Clickable Product Info -->
                    <div
                      class="flex-grow-1 d-flex flex-column"
                      @click="selectItem(item)"
                      style="cursor: pointer;"
                    >
                      <div class="d-flex align-items-center gap-2">
                        <!-- Image Wrapper -->
                        <div
                          style="width:50px; height:50px; border-radius:4px; overflow:hidden; flex-shrink:0;"
                        >
                          <img
                            :src="$getImageUrl(item.images)"
                            alt="Items"
                            style="width:100%; height:100%; object-fit:cover;"
                          />
                        </div>

                        <!-- Item Info -->
                        <div class="d-flex flex-column">
                          <strong class="text-dark">{{ item.item_name }} - {{ item.item_code }}</strong>
                          <span
                            style="font-size: 0.75rem; width: fit-content; color: black"
                          >
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <!-- No Results -->
                <div v-if="!results.length" class="text-center text-muted py-3" style="font-size: 0.9rem;">
                  No results found
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 d-flex align-items-start">
            <label class="form-label small mb-0 me-3" style="width:85px;">{{$t('Select Print Type')}}:</label>

            <select v-model="printType" class="form-control">
              <option value="a4">A4 Sticker</option>
              <option value="thermal">Thermal (80mm)</option>
            </select>
          </div>
        </div>

        <div class="table-responsive gy-2 gx-4 mb-3 p-3 fixed-table">
          <table class="table table-bordered align-middle mb-0">
            <thead class="table-light sticky-top">
              <tr>
                <th style="width: 8.33%">{{$t('item_name')}}</th>
                <th style="width: 8.33%">{{$t('item_code')}}</th>
                <th style="width: 8.33%">{{$t('total_quantity')}}</th>
                <th style="width: 10%">{{$t('print_qty')}}</th>
                <th style="width: 10%" >{{$t('action')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cust, index) in addedItems" :key="index">
                <td class="readonly-cell">{{ cust.item_name }}</td>
                <td class="readonly-cell">{{ cust.item_code }}</td>
                <td class="readonly-cell">{{ cust.stock_quantity }}</td>
                <td class="dynamic-cell">
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="cust.print_qty"
                    min="1"
                    :max="cust.stock_quantity"
                  />
                </td>

                <td class="dynamic-cell">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click="removeItem(index)"
                  >
                    Delete
                  </button>
                </td>
              </tr>

              <!-- Show empty row if no data -->
              <tr v-if="!addedItems || !addedItems.length">
                <td colspan="11" class="text-center text-muted">No Items added</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Buttons Row -->
        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
          <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('print_preview') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import VueSelect2 from "vue3-select2-component";
import feather from "../../../../public/assets/js/feather.min";
import { useToast } from 'vue-toastification';

export default {
  components: {
    Vue3Datepicker,
    VueSelect2,
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      item: {
        item_id: null, item: null, quantity: 0, item_price: 0,
        print_qty: 1,
      },
      printType: 'a4',
      errors: {},
      errorMessage: "",
      query: "",
      results: [],
      itemIndex: 0,
      selectedItem: null,
      addedItems: [],
    };
  },

  mounted() {
    this.printType = localStorage.getItem('printType') || 'a4';
  },

  watch: {
    addedItems: {
      deep: true,
      handler(newItems) {
        newItems.forEach(item => {
          if (isNaN(item.print_qty) || item.print_qty < 1) {
            item.print_qty = 1;
          }
          if (item.print_qty > item.stock_quantity) {
            item.print_qty = item.stock_quantity;
          }
        });
      }
    },

    printType(val) {
      localStorage.setItem('printType', val);
    }
  },

  methods: {
    async searchItems() {
      if (!this.query) {
        this.results = [];
        return;
      }

      try {
        const response = await this.$axios.get(apiUrls.item_search.get, {
          params: { q: this.query }
        })
        this.results = response.data.results || [];
        this.itemIndex = 0;

        // render feather icons
        await this.$nextTick(() => {
          if (window.feather) feather.replace()
        })
      } catch (error) {
        this.results = [];
        this.addedItems = [];
      }
    },

    selectItem(item) {
      const totalQty = Number(item.stock_quantity || 0);

      this.selectedItem = item;
      this.query = item.item_name;

      // Check if item already exists in addedItems
      const existingItem = this.addedItems.find(i => i.item_id === item.id);

      if (!totalQty || totalQty <= 0) {
        this.toast.warning("This item has no available quantity!");
        return;
      }

      if (existingItem) {
        this.toast.warning("This item is already added!");
        return;
      }

      // Add selected item to the addedItems list
      this.addedItems.push({
        item_id: item.id,
        item_name: item.item_name,
        item_code: item.item_code,
        item_price: item.selling_price,
        barcode: item.barcode,
        stock_quantity: item.stock_quantity,
        print_qty: item.print_qty,
      });

      // Clear search results and form input fields
      this.results = [];
      this.itemIndex = 0;
      this.query = "";
    },

    handleKeys(event) {
      if (event.key === 'ArrowDown') {
        this.itemIndex = Math.min(this.itemIndex + 1, this.results.length - 1);
        event.preventDefault();
      } else if (event.key === 'ArrowUp') {
        this.itemIndex = Math.max(this.itemIndex - 1, 0);
        event.preventDefault();
      } else if (event.key === 'Enter') {
        const selectedProduct = this.results[this.itemIndex];
        if (selectedProduct) {
          this.selectItem(selectedProduct);
        }
        event.preventDefault();
      }
    },

    async printBarcodes() {
      if (!this.addedItems.length) {
        this.toast.warning("No items to print");
        return;
      }

      const invalid = this.addedItems.some(
          item => item.print_qty < 1 || item.print_qty > item.stock_quantity
      );

      if (invalid) {
        this.toast.warning("Invalid print quantity");
        return;
      }

      const payload = {
        print_type: this.printType,
        items: this.addedItems.map(item => ({
          item_code: item.item_code,
          item_name: item.item_name,
          qty: item.print_qty,
          item_price: item.item_price
        }))
      };

      try {
        if (this.printType === "thermal") {
          await this.$axios.post(apiUrls.print_barcodes.post, payload);
          this.toast.success("Printed successfully");
        } else {
          const res = await this.$axios.post(apiUrls.print_barcodes.post, payload, {
            responseType: 'text'
          });

          const printWindow = window.open('', '_blank');
          printWindow.document.write(res.data);
          printWindow.document.close();

          printWindow.onload = function () {
            printWindow.print();
          };
        }

        // this.addedItems = []; // reset after print
      } catch (error) {
        this.toast.error("Failed to print barcodes");
      }
    },

    cancelForm() {
      this.$router.push('/');
    },

    removeItem(index) {
      this.addedItems.splice(index, 1);
      this.query = '';
    },

    resetForm() {
      // Reset form fields and errors
      this.item = {
        id: null, item: null, stock_quantity: 0,
        print_qty: 0,
      };
      this.errors = {};
      this.errorMessage = "";
    },

  },
};
</script>


<style scoped>
/* Optional: adjust table and input heights */
.table td, .table th {
  vertical-align: middle;
}

.fixed-table {
  min-height: 350px;
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}

.readonly-cell {
  background-color: #fffbe6 !important;
  font-weight: bold;
}

.dynamic-cell {
  background-color: #e6fffb !important;
}

</style>

